import * as React from 'react';
import { StylesProps } from 'src/Library/Types';
import withStyles from 'react-jss';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Button from 'antd/lib/button';
import Skeleton from 'antd/lib/skeleton';
import Tooltip from 'antd/lib/tooltip';
import { SearchParams } from './TypesInDiscoverRates/DiscoverRatesCommon';
import { renderDot, renderLine } from 'src/Library/Common';
import { commonStyles, buttonStyle } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';
import { connect } from 'react-redux';
import { getCargoAndProduct, getContainer, equal, isValidArray } from 'src/Library/Helper';
import { CargoList, ContainerList, Currency } from 'src/components/common/Types/CommonTypes';
import { getDiscoverRatesRoute } from 'src/routing/utils';
import { bindActionCreators } from 'redux';
import {
  setSearchFilterValues,
  fetchAllData,
  getAllDataSetSortByFilter,
  getAllDataResetFilter,
} from 'src/actions/discoverRatesActions';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import { useGenericState } from 'src/Library/UseGenericState';
import { rateDigitisationDiscoverRates } from 'src/api/discoverRates';
import { FreightPrice } from './TypesInDiscoverRates/FreightPrice';
import { savedInLocalStorage } from './DiscoverRateUtils';
import { SearchResult } from './TypesInDiscoverRates/SearchResult';
import { getUnitByMode } from '../Enquiry/InquiryUtils';
import { InquiryModes } from 'src/Library/Constants';
const noRatesAvailableSrc = require('src/assets/images/no_rates_available.png');

const styles = (theme) => ({
  mainDiv: {
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    boxShadow: '2px 2px 8px 0 rgba(0,0,0,0.02)',
    marginBottom: '12px',
    padding: '16px 24px',
    ...commonStyles(theme).flexRow,
  },
  line: {
    display: 'flex',
    flex: 1,
    height: 1,
    backgroundColor: '#58C7EC',
  },
  dot: {
    height: '6px',
    width: '6px',
    borderRadius: '5px',
    display: 'inline-block',
    border: '1px solid #333333',
  },
  lineAndDot: {
    ...commonStyles(theme).flexRow,
    width: '56px',
    justifyContent: 'flex-start',
  },
  port: {
    ...commonStyles(theme).flexRow,
    fontSize: '16px',
    fontWeight: 600,
    width: '34%',
  },
  route: {
    ...commonStyles(theme).flexRow,
  },
  containerCargoInfo: {
    ...commonStyles(theme).flexRow,
    color: '#555555',
    marginTop: '4px',
  },
  viewAllButton: {
    ...buttonStyle('#FFFFFF', '#006EC3', '1px solid #006EC3'),
    padding: '0 16px',
  },
  viewAllButtonDisabled: {
    ...buttonStyle('#FFFFFF', '#CCCCCC', '1px solid #CCCCCC'),
    padding: '0 16px',
    cursor: 'not-allowed',
  },
  freightInfo: {
    ...commonStyles(theme).justifySpaceBetween,
    paddingLeft: '21px',
    alignItems: 'center',
  },
  ellipsis: {
    marginRight: '4px',
    ...commonStyles(theme).ellipses,
  },
  noRates: {
    color: '#999999',
    fontSize: '10px',
    fontWeight: 600,
    ...commonStyles(theme).flexRow,
  },
  perContainer: {
    fontSize: '8px',
    fontStyle: 'italic',
    marginLeft: '4px',
    fontWeight: 'normal',
    color: '#333333',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  cardData: SearchParams;
  cargoList: CargoList [];
  containerList: ContainerList [];
  setSearchFilterValues: (e : Partial<SearchFilters>) => void;
  fetchAllData: (isSearch?: boolean) => {};
  getAllDataResetFilter: (apiCall? : boolean, fromURL?: boolean) => void;
  getAllDataSetSortByFilter: (val, apiCall?: boolean) => void;
  history: any;
  currencySymbols: any;
  orgType: string;
  mode: InquiryModes;
}

interface StateProps {
  isLoading: boolean;
  cardResults: {
    searchResults: SearchResult [],
    freightPrice: FreightPrice,
  };
  cheapestFreightLoaded: boolean;
}

const RecentOrTrandingCard = (props: IProps) => {
  const { 
    classes,
    cardData,
    cargoList,
    containerList,
    history,
    setSearchFilterValues,
    fetchAllData,
    getAllDataResetFilter,
    getAllDataSetSortByFilter,
    currencySymbols,
    orgType,
    mode
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    isLoading: false,
    cardResults: {
      searchResults: [],
      freightPrice: {
        min: 0,
        max: 0,
        currency: Currency.USD,
      },
    },
    cheapestFreightLoaded: false,
  });

  const {
    isLoading,
    cardResults,
    cheapestFreightLoaded,
  } = state;

  const SavedValues = JSON.parse(localStorage.getItem(savedInLocalStorage.SAVED_SEARCH) || '[]');

  React.useEffect(() => {
    fetchCardResults();
  }, []);

  const renderLineAndDots = (): React.ReactElement => {
    return (
      <span className={classes.lineAndDot}>
        {renderDot('', classes.dot)}
        {renderLine(classes.line)}
        {renderDot('', classes.dot)}
      </span>
    );
  };

  const renderPort = (type) : React.ReactElement => {
    return (
      <span className={classes.ellipsis}>
        <img style={{ maxWidth: '21px', marginRight: '6px' }}
          src={cardData[type]?.flagS3Link} />
        <Tooltip
          placement="topLeft"
          title={cardData[type]?.name || cardData[type]?.city || cardData[type]?.state}
          mouseEnterDelay={0.5}>
          {cardData[type]?.name || cardData[type]?.city || cardData[type]?.state}
        </Tooltip>
      </span>
    );
  };

  const renderContainerCargoInfo = () : React.ReactElement => {
    const container = getContainer(containerList, cardData.container);
    const cargo = getCargoAndProduct(cargoList, cardData.cargo);
    const {incoterm, movementType, grossWeight, totalVolume, totalVolumetricWeight} = cardData;
    return (
      <div className={classes.containerCargoInfo}>
        {container?.label?.type && <Tooltip
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}
          title={`${container?.label?.type} - ${container?.label?.size}`}
        >
          <span className={classes.ellipsis}
            style={{fontSize: '12px'}}>
           {container?.label?.type} - {container?.label?.size}
          </span>
        </Tooltip>}
        <Tooltip
          title={cargo?.value}
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}>
          <span className={classes.ellipsis}
            style={{fontSize: '12px', maxWidth: totalVolumetricWeight && '30%'}}>
          {container?.label?.type && '|'} {cargo?.value}
          </span>
        </Tooltip>
        {incoterm && movementType && <Tooltip
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}
          title={`${incoterm} - ${movementType}`}
        >
          <span className={classes.ellipsis}
            style={{fontSize: '12px'}}>
            | {incoterm + " - " + movementType}
          </span>
        </Tooltip>}
        {grossWeight && <Tooltip
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}
          title={`Gross Weight: ${grossWeight?.value} ${grossWeight?.unit}`}
        >
          <span className={classes.ellipsis}
            style={{fontSize: '12px'}}>
            | {grossWeight?.value + " " + grossWeight?.unit}
          </span>
        </Tooltip>}
        {totalVolume && <Tooltip
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}
          title={`Total Volume: ${totalVolume?.value} ${totalVolume?.unit}`}
        >
          <span className={classes.ellipsis}
            style={{fontSize: '12px'}}>
            | {totalVolume?.value + " " + totalVolume?.unit}
          </span>
        </Tooltip>}
        {totalVolumetricWeight && <Tooltip
          mouseEnterDelay={0.5}
          overlayStyle={{fontSize: '12px'}}
          title={totalVolumetricWeight?.value + " " + totalVolumetricWeight?.unit}
        >
          <span className={classes.ellipsis}
            style={{fontSize: '12px'}}>
            | Vol. Wt.- {totalVolumetricWeight?.value + " " + totalVolumetricWeight?.unit}
          </span>
        </Tooltip>}
      </div>
    );
  };

  const renderRouteInfo = () : React.ReactElement => {
    return (
      <div className={classes.route}>
        <span className={classes.port}>{renderPort('pol')}</span>
        <span style={{ padding: '0px 6px' }}>{renderLineAndDots()}</span>
        <span className={classes.port}
          style={{ marginLeft: '8px' }}
        >{renderPort('pod')}</span>
      </div>
    );
  };

  const setSavedArray = (object) : void => {
    const duplicateSearch = SavedValues.findIndex((item) => {
      return equal(item, object);
    });
    // calculated count mode wise so that we store at max 10 values for each mode in localStorage
    const modeWiseSearchLength = SavedValues.reduce((acc, cur) => acc += cur.mode === mode ? 1 : 0, 0)
    if (duplicateSearch !== -1) {
      SavedValues.splice(0, 0, SavedValues.splice(duplicateSearch, 1)[0]);
    } else {
      modeWiseSearchLength >= 10 && SavedValues.pop();
      SavedValues.unshift(object);
    }
  };

  const addToLocalStorage = (data) : void => {
    setSavedArray(data);
    window.localStorage.setItem(savedInLocalStorage.SAVED_SEARCH,
      JSON.stringify(SavedValues));
  };

  const handleViewAll = () : void => {
    setState({ isLoading: true });
    const containerSelectedMaster = getContainer(containerList, cardData.container);
    const cargoSelectedMaster = getCargoAndProduct(cargoList, cardData.cargo);
    const { incoterm, movementType, grossWeight, totalVolume, totalVolumetricWeight } = cardData
    const containerSelected = {
      key: containerSelectedMaster?.key,
      label: containerSelectedMaster?.label,
    };
    const cargoSelected = {
      key: cargoSelectedMaster?.key,
      label: cargoSelectedMaster?.label,
    };
    const container = JSON.stringify(containerSelected || '[]');
    const cargo = JSON.stringify(cargoSelected || '[]');
    cardData.pol.code = cardData.pol.code || cardData.pol?.city || cardData.pol?.state || '';
    cardData.pod.code = cardData.pod.code || cardData.pod?.city || cardData.pod?.state || '';
    setSearchFilterValues({
      mode,
      container,
      cargo,
      pol: cardData.pol,
      pod: cardData.pod,
      ...(incoterm && movementType && { incoterm, movementType }),
      ...(grossWeight && { grossWeight }),
      ...(totalVolume && { totalVolume }),
      ...(totalVolumetricWeight && { totalVolumetricWeight })
    });
    addToLocalStorage({
      mode,
      ...(cardData.container && {container: containerSelected}),
      cargo: cargoSelected,
      pol: cardData.pol,
      pod: cardData.pod,
      ...(incoterm && movementType && { incoterm, movementType }),
      ...(grossWeight && { grossWeight }),
      ...(totalVolume && { totalVolume }),
      ...(totalVolumetricWeight && { totalVolumetricWeight })
    }),
    fetchAllData(true);
    getAllDataResetFilter(false ,false);
    getAllDataSetSortByFilter({ sortBy: 'totalPrice' }, false);
    history.push(getDiscoverRatesRoute('buy'));
    setState({ isLoading: false });
  };

  const renderViewAllButton = () : React.ReactElement => {
    return (
      <React.Fragment>
        <Button
          className={isSearchResultsAvailable() ? classes.viewAllButton : classes.viewAllButtonDisabled}
          onClick={() => {
            if (!isSearchResultsAvailable()) {
              return;
            }
            handleViewAll()
          }}
          loading={isLoading}
        >
          View All
        </Button>
      </React.Fragment>
    );
  };

  const isSearchResultsAvailable = () => {
    return isValidArray(cardResults?.searchResults);
  };

  const renderCheapestFreight = () : React.ReactElement => {
    return (
      <div>
        <div
          style={{
            color: '#333333',
            fontSize: '21px',
            fontWeight: 'bold',
          }}
        >
          {currencySymbols[cardResults.freightPrice?.currency]}{Math.round(cardResults.freightPrice?.min)}
          <span className={classes.perContainer}>
            Per {getUnitByMode(mode)}
          </span>
        </div>
        <div
          style={{
            color: '#666666',
            fontSize: '10px',
          }}
        >
          Cheapest Freight Price
        </div>
      </div>
    );
  };

  const renderNoRatesFound = () : React.ReactElement => {
    return (
      <div className={classes.noRates}>
        <img
          src={noRatesAvailableSrc}
          style={{
            height: '24px',
            width: '24px',
            marginRight: '12px',
          }}
        />
        No Rates <br/>Available
      </div>
    );
  };

  const fetchCardResults = async () => {
    const { container, cargo, incoterm, movementType, grossWeight, totalVolume, totalVolumetricWeight } = cardData;
    const response = await rateDigitisationDiscoverRates({
      polId: cardData.pol?.id,
      podId: cardData.pod?.id,
      container,
      cargo,
      incoterm,
      movementType,
      mode,
      view: 'BUY',
      grossWeight, 
      totalVolume,
      totalVolumetricWeight,
      doNotSaveSearchResults: true,
      ...([InquiryModes.DOMESTIC, InquiryModes.TRAILER].includes(mode)
        ? {
            originCity: cardData.pol?.city,
            originState: cardData.pol?.state,
            originCountryId: cardData.pol?.countryId,
            destinationCity: cardData.pod?.city,
            destinationState: cardData.pod?.state,
            destinationCountryId: cardData.pod?.countryId,
            vehicle: { ...container },
          }
        : {})
    });
    let cardResults;
    if (response.isSuccess) {
      cardResults = response.data;
    }
    setState({
      cardResults,
      cheapestFreightLoaded: true,
    });
  };

  return (
    <Row className={classes.mainDiv}>
      <Col span={15}
        style={{ borderRight: `1px solid ${tokens.colors.border}` }}>
        {renderRouteInfo()}
        {renderContainerCargoInfo()}
      </Col>
      <Col span={9} className={classes.freightInfo}>
        {cheapestFreightLoaded ?
          <React.Fragment>
            {isSearchResultsAvailable() ? renderCheapestFreight() : renderNoRatesFound()}
            {renderViewAllButton()}
          </React.Fragment> :
          <Skeleton active title={false} paragraph={{ rows: 2 }}/>}
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ masterData }, ownProps) => ({
  containerList: masterData.containerList,
  cargoList: masterData.cargoList,
  currencySymbols: masterData.currencySymbols,
  orgType: masterData.userData.type,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setSearchFilterValues,
    fetchAllData,
    getAllDataResetFilter,
    getAllDataSetSortByFilter,
  },
    dispatch,
);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(withStyles(styles)(RecentOrTrandingCard)));
